import type { Theme } from '@mui/material'

/**
 * The sidebar's own surface colour.
 *
 * Light is #fafafa — a half-step off the white page, so the sidebar reads as a surface
 * without becoming a grey slab. Dark uses primary[50], which is the raised tone in that
 * mode.
 *
 * IN ITS OWN MODULE because four places need it: the expanded rail, the collapsed rail,
 * the footer wrapper (all in Sidebar.tsx) and the sticky profile block in
 * SidebarUserBlock. Sidebar imports SidebarUserBlock, so exporting it from Sidebar.tsx
 * would make an import cycle — and a `const` arrow function in a cycle can be read
 * before initialisation, which fails at runtime rather than at build.
 *
 * The helper originally lived in Sidebar.tsx with a comment saying it existed so the
 * colour was set "by construction rather than by coincidence" across three places
 * including the footer block — but the profile block was never converted and stayed on
 * `gray[50]`, a different value. That is why the profile row rendered as a distinct grey
 * panel against a #fafafa sidebar. The helper described the intent; one caller never
 * adopted it.
 */
export const sidebarSurface = (theme: Theme): string =>
  theme.palette.mode === 'light' ? '#fafafa' : (theme.palette as any).primary[50]
